var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Medication Details") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medications",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pills",
    transform: "translate(0.659651, 3.632928)",
    fill: "#A31922",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.57705007,0.148023978 C5.29327423,-0.463911915 2.95285083,0.876988945 2.34496583,3.14564666 L0.145188115,11.3553288 C-0.462696887,13.6239866 0.8937188,15.9554525 3.17749464,16.5673884 C5.46127048,17.1793243 7.80169388,15.8384234 8.40957888,13.5697657 L10.6093566,5.36008349 C11.2172416,3.09142578 9.86082591,0.75995987 7.57705007,0.148023978 Z M7.73852686,8.99040241 L3.01601785,7.72500993 L4.11590671,3.62016884 C4.94769765,0.515882757 9.67020666,1.78127523 8.83841572,4.88556131 L7.73852686,8.99040241 Z M20.5693916,7.47723716 C18.4099289,5.33206967 14.900802,5.3286319 12.7378787,7.47723716 C10.5749553,9.62584242 10.5749553,13.1083018 12.7378787,15.2569071 C14.8973413,17.4020746 18.4064682,17.4055123 20.5693916,15.2569071 C22.732315,13.1083018 22.732315,9.62240465 20.5693916,7.47723716 Z M13.3954074,9.29237888 L18.7421539,14.6037311 C15.2607125,16.8245295 11.1528884,12.7576494 13.3954074,9.29237888 Z M19.9153236,13.4383276 L14.568577,8.12697539 C18.0500184,5.90273922 22.1578425,9.97305703 19.9153236,13.4383276 L19.9153236,13.4383276 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedications);
export default __webpack_public_path__ + "static/media/Medications.25af2124.svg";
export { ForwardRef as ReactComponent };